import styled from "styled-components";
import media from "styled-media-query";

export const SidebarWrapper = styled.aside`
  align-items: center;
  border-right: 1px solid var(--borders);
  border-bottom: 1px solid var(--borders);
  background: var(--mediumBackground);
  display: flex;
  flex-direction: column;
  height: 45vh;
  position: fixed;
  padding: 2rem;
  text-align: center;
  width: 18rem;
  top: 15%;
  margin: 0 1.5rem;
  border-radius: 10px;

  ${media.lessThan("large")`
    align-items: flex-start;
    height: auto;
    top: 0;
    margin: 0;
    border-radius: 0;
    padding: 1rem 2rem;
    width: 100%;
  `}
`;

export const DevelopedBy = styled.span`
  color: var(--texts);

  & a {
    color: blueviolet;
    font-weight: 750;
    text-decoration: none;
  }

  ${media.lessThan("large")`
    display: none;
  `}
`;
